export default "__VITE_ASSET__BDb0cxJn__"